import axios from 'axios'

export default {
    getCurrencies({ current_page = 1, per_page = 20, data = {} }) {
        return axios.get(`/api/currencies/${current_page}/${per_page}`, { params: { ...data } })
    },
}
